import React from 'react';
import Accordion from "@scentregroup/ui/components/accordion";
import Icon from "@scentregroup/ui/components/icon";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { Link } from '@hub/link';
import classNames from 'classnames';
import TradingHoursLine, { ThemeTypes } from '../trading-hours-line';
import UtilityBoxItem from '../utility-box-item';
import style from './index.module.scss';
import { SEE_MORE_OPENING_HOURS_TEXT } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function calculateNumberOfHoursDisplayed(parsedHours) {
  const MAX_DISPLAYED_DAYS = 7;
  const numberOfDaysDisplayed = Math.min(MAX_DISPLAYED_DAYS, parsedHours.length);
  return parsedHours.slice(0, numberOfDaysDisplayed);
}
const UtilityBoxOpeningHours = _ref => {
  let {
    openingHours,
    centreSlug,
    unlinkedHours,
    wrapperNoBorder,
    headerNoPadding,
    withinV2Design,
    seeMoreOpeningHoursUrl
  } = _ref;
  if (openingHours.length === 0) {
    return null;
  }
  const displayedHours = calculateNumberOfHoursDisplayed(openingHours);
  const headerHours = displayedHours[0];
  const contentHours = displayedHours.slice(1);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Accordion, {
      name: "Opening Hours",
      id: "opening-hours",
      type: "small",
      classNames: {
        wrapper: classNames(style.openingHoursWrapper, {
          [style.wrapperNoBorder]: wrapperNoBorder
        }),
        header: classNames(style.openingHoursTitle, {
          [style.headerNoPadding]: headerNoPadding
        }),
        content: style.openingHoursContent
      },
      headerElement: /*#__PURE__*/_jsxs("div", {
        className: style.headerElement,
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_div",
        children: [/*#__PURE__*/_jsx(Icon, {
          type: "hours",
          className: style.image,
          role: "heading",
          "aria-label": "Opening hours Icon",
          "aria-level": "4",
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_div_Icon"
        }), /*#__PURE__*/_jsx(TradingHoursLine, {
          openHourDay: headerHours,
          theme: ThemeTypes.leftAligned,
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_div_TradingHoursLine"
        })]
      }),
      "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Accordion",
      children: /*#__PURE__*/_jsxs("div", {
        className: withinV2Design ? style.tradingHoursLinesContainer : '',
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Accordion_div",
        children: [contentHours.map(day => /*#__PURE__*/_jsx(TradingHoursLine, {
          openHourDay: day,
          theme: ThemeTypes.leftAligned,
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_TradingHoursLine"
        }, day.day)), seeMoreOpeningHoursUrl && /*#__PURE__*/_jsx(Link, {
          href: seeMoreOpeningHoursUrl,
          hasUnderline: true,
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Link",
          children: SEE_MORE_OPENING_HOURS_TEXT
        })]
      })
    }), unlinkedHours && /*#__PURE__*/_jsxs(UtilityBoxItem, {
      icon: "hours",
      role: "heading",
      "aria-label": "Hours may differ",
      "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_UtilityBoxItem",
      children: [/*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_UtilityBoxItem_Paragraph",
        children: "Hours may differ from Centre hours"
      }), /*#__PURE__*/_jsx(Paragraph, {
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_UtilityBoxItem_Paragraph_9",
        children: /*#__PURE__*/_jsx(Link, {
          href: "/".concat(centreSlug, "/opening-hours"),
          className: style.differentHoursLink,
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Paragraph_Link",
          children: "View Centre Hours"
        })
      })]
    })]
  });
};
UtilityBoxOpeningHours.defaultProps = {
  openingHours: [] // eslint-disable-line react/default-props-match-prop-types
};

export default UtilityBoxOpeningHours;